import Log from "./log";
export function throwErrorAndLog(error: string) {
  Log.error(error);
  throw new Error(error);
}
